<script>
import LayoutMember from '@layout/Member'
import OrderSession from '@components/List/OrderSession'
import { brandOptions } from '@utils/zerone-options'
// import { FAKE_ORDER_LIST } from "@src/config/fake-order";
// import { FAKE_PAGINATION } from "@src/config/fake-pagination";

import { getDefaultBrand, getDefaultMonth } from '@utils/zerone-get-default'
import monthToDate from '@utils/format-mouth-to-date'
import setWindowHistory from '@utils/window-history'

const DEFAULT_SEARCH = {
  category: '',
  type: '',
  month: '',
  city: '',
  brand: '',
}

export default {
  page() {
    return {
      title: `報名清單`,
    }
  },
  components: {
    LayoutMember,
    OrderSession,
  },
  data() {
    return {
      courseList: [],
      pagination: {},
      searchData: {
        month: getDefaultMonth(this.$route.query.month) || DEFAULT_SEARCH.month,
        brand: getDefaultBrand(this.$route.params.brandAlias || this.$route.query.brand) || DEFAULT_SEARCH.brand,
      },
      searchList: [
        {
          width: '50%',
          type: 'select',
          placeholder: '品牌篩選',
          name: 'brand',
          clearable: true,
          options: brandOptions(),
        },
        {
          width: '50%',
          type: 'month',
          placeholder: '不限時間',
          name: 'month',
          clearable: true,
          valueFormat: 'yyyy-MM',
        },
      ],
      loadingFetchOrderList: false,
      isShowFilterMenu: false,
      activeName: this.$route.name === 'member-activity-list' ? 'activity' : 'event',
    }
  },
  computed: {
    // checkSearchDataValue() {
    //   const url = new URL(window.location);
    //   Object.keys(query)
    //     .forEach(key => {
    //       if(query[key] === undefined) {
    //         url.searchParams.delete(key)
    //       } else {
    //         url.searchParams.set(key, query[key]);
    //       }
    //     });
    //   window.history.pushState(data, title, url);
    //   // return Object.entries(this.searchData).some(([key,value])=> {
    //   //   console.log(value === '')
    //   //   return value !== '' && value !== null && value !== undefined
    //   // })
    //   return true
    // }
  },
  created() {
    this.tryToFetchOrderList()
  },
  methods: {
    onSubmit() {
      setWindowHistory({
        query: {
          // ...this.$route.query,
          page: 1,
        },
      })
      this.tryToFetchOrderList({
        storeParams: {
          // ...this.$route.params,
          page: 1,
        },
      })
    },
    onChangePagination(page) {
      this.tryToFetchOrderList({
        storeParams: {
          // ...this.$route.params,
          page,
        },
      })
    },
    tryToFetchOrderList({ storeParams } = {}) {
      this.loadingFetchOrderList = true

      this.$store
        .dispatch('order/fetchOrderList', {
          ...this.searchData,
          ...monthToDate(this.searchData.month),
          eventCategoryAlias: this.$route.params.eventCategoryAlias,
          brandAlias: this.searchData.brand,
          page: this.$route.query.page,
          ...storeParams,
        })
        .then((response) => {
          this.courseList = response.items
          this.courseListPagination = response.pagination
        })
        .finally(() => {
          this.loadingFetchOrderList = false
        })
    },
    onClearSearch() {
      Object.keys(this.searchData).forEach((key) => {
        this.searchData[key] = undefined
      })
      setWindowHistory({
        query: {
          ...this.$route.query,
          ...this.searchData,
          page: 1,
        },
      })
      this.tryToFetchOrderList({
        storeParams: {
          page: 1,
        },
      })
    },
    onOpenFilter(status) {
      this.isShowFilterMenu = status
    },
    onChangePage() {
      this.$router.replace({
        name: `member-${this.activeName}-list`,
        params: {},
      })
    },
  },
}
</script>
<template>
  <LayoutMember>
    <template v-slot:banner>
      <BaseBanner
        :title="$route.name === 'member-activity-list' ? '零壹活動' : '零壹課程'"
        :image="require('@assets/images/member/banner.png')"
        custom-class="isStyleWhite"
        @openFilter="onOpenFilter(!isShowFilterMenu)"
      />
    </template>
    <div :class="$style.memberList">
      <div class="text-2xl font-medium mb-5 d-md-block d-none">
        {{ $route.name === 'member-activity-list' ? '零壹活動' : '零壹課程' }}
      </div>
      <BaseSearchBar
        v-model="searchData"
        :list="searchList"
        :is-show-filter="isShowFilterMenu"
        :submit-text="$route.name === 'member-activity-list' ? '零壹活動' : '零壹課程'"
        @search="onSubmit"
        @openFilter="onOpenFilter(false)"
      />
      <el-tabs v-model="activeName" class="d-md-none d-block isStyleBase mb-5" stretch @tab-click="onChangePage">
        <el-tab-pane label="零壹課程" name="event"></el-tab-pane>
        <el-tab-pane label="零壹活動" name="activity"></el-tab-pane>
      </el-tabs>
      <template v-if="!!courseList.length">
        <OrderSession v-loading="loadingFetchOrderList" :order-list="courseList" />
        <BasePagination2 :pagination="pagination" @change="onChangePagination" />
      </template>
      <template v-else>
        <BaseNull :content="`尚未有報名的${$route.name === 'member-event-list' ? '課程' : '活動'}`">
          <!-- <BaseButton
            :to="{
              name: 'event-list',
              query: {
                category: $route.name === 'member-event-list' ? 'course' : 'activity',
              },
            }"
            class="isStylePrimary isCol4 isRadius mt-5">
            
          </BaseButton> -->
        </BaseNull>
      </template>
    </div>
  </LayoutMember>
</template>
<style lang="scss" module>
.memberList {
  @include max-md {
    min-height: calc((var(--vh, 1vh) * 100) - 163px);
  }
  :global {
    .memberList {
    }
  }
}
</style>
